@if (isInitialized && isPartnershipAllowed) {
  <div>
    @if (!isPartner  && !isPartnerPending) {
      <app-become-partner></app-become-partner>
    }
    @if (isPartner && !isPartnerPending) {
      <app-partnership-view></app-partnership-view>
    }
    @if (isPartnerPending) {
      <app-partner-pending></app-partner-pending>
    }
  </div>
}
